import { Injectable } from '@angular/core';
import { BaseService } from '../../base.service';
import { HttpService } from '../../http.service';
import { environment } from '../../../environments/environment';
import { MessageService } from 'primeng/components/common/messageservice';
import { DistributorContract } from '../../models/distributor-contract';
import { Observable } from 'rxjs/Observable';
import { Headers, RequestOptions } from '@angular/http';

@Injectable()
export class DistributorContractsService extends BaseService
{
	private api: string;

	constructor(private http: HttpService, private messageService: MessageService)
	{
		super();
		this.api = environment.api_url;
	}

	public getDistributorContract(id: number): Promise<DistributorContract>
	{
		return this.http
			.get(this.api + 'distributor-contracts/' + id)
			.toPromise()
			.then(response => response.json().data as DistributorContract)
			.catch(this.handleError);
	}

	public removeDistributorContract(id: number): Promise<null>
	{
		return this.http
			.delete(this.api + 'distributor-contracts/' + id)
			.toPromise()
			.then(response => null)
			.catch(this.handleError);
	}

	public uploadContractFile(distributorContract: DistributorContract, file: File): Observable<Response>
	{
		const headers = new Headers();
		const options = new RequestOptions({headers: headers});

		const formData = new FormData();

		if (file) {
			formData.append('contract_file', file);
		}

		return this.http.post(this.api + 'distributor-contracts/' + distributorContract.id + '/pdf', formData, options)
			.map(response => response.json());
	}

	public deleteContractFile(distributorContract: DistributorContract): Observable<DistributorContract>
	{
		return this.http.delete(this.api + 'distributor-contracts/' + distributorContract.id + '/pdf')
			.map(response => response.json().data as DistributorContract);
	}

	public streamContractFile(distributorContract: DistributorContract)
	{
		window.open(this.api + 'distributor-contracts/' + distributorContract.id + '/pdf');
	}

	public updateDistributorContract(distributorContract: DistributorContract): Promise<DistributorContract>
	{
		return this.http
			.put(this.api + 'distributor-contracts/' + distributorContract.id, JSON.stringify(distributorContract))
			.toPromise()
			.then(response => {
				return response.json().data as DistributorContract;
			})
			.catch(this.handleError);
	}

	public storeDistributorContract(distributorContract: DistributorContract, file?: File): Promise<DistributorContract>
	{
		return this.http
			.post(this.api + 'distributor-contracts', JSON.stringify(distributorContract))
			.toPromise()
			.then(response => {
				const contractData = response.json().data as DistributorContract;

				if (file) {
					this.uploadContractFile(contractData, file).subscribe(
						data => {
							this.messageService.add({
								severity: 'success',
								summary: 'Bestand geüpload',
								detail: 'Het contract bestand is geüpload'
							});
						},
						err => {
							this.messageService.add({
								severity: 'error',
								summary: 'Bestand niet geüpload',
								detail: 'Er is een fout opgetreden bij het uploaden van het bestand'
							});
						}
					);
				}

				return contractData;
			})
			.catch(this.handleError);
	}

	public duplicateDistributorContract(distributorContract: DistributorContract): Promise<DistributorContract>
	{
		return this.http
			.post(this.api + 'distributor-contracts/duplicate/' + distributorContract.id, JSON.stringify(distributorContract))
			.toPromise()
			.then(response => {
				const contractData = response.json().data as DistributorContract;

				return contractData;
			})
			.catch(this.handleError);
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/services/distributor-contracts.service.ts